const resultFunction = (config) => {
  const result = {}

  if (config?.providers) {
    for (const [provider, values] of Object.entries(config.providers)) {
      result[provider] = values?.enabled
    }
  }

  return result
}

const getProviderAvailabilitySelectorDefinition = {
  id: 'getProviderAvailability',
  resultFunction,
  dependencies: [{ selector: 'configData' }],
}

export default getProviderAvailabilitySelectorDefinition
